<app-navbar title="Dodaj wycieczke">
	<button class="btn btn-warning me-2" *ngIf="pageFunction !== 'add'" (click)="deleteAsk()">Usuń</button>
	<a class="btn btn-danger" routerLink="../"> <i class="fas fa-chevron-left"></i> Powrót </a>
</app-navbar>

<div class="container col-auto my-4">
	<ng-select
		id="destination"
		name="destination"
		[(ngModel)]="data.destinations"
		[multiple]="true"
		placeholder="Destynacja"
	>
		<ng-option *ngFor="let item of locations" [value]="item.id">{{ item.name }}</ng-option>
	</ng-select>
	<div class="form-floating my-4">
		<input type="text" [(ngModel)]="data.name" name="name" class="form-control" />
		<label for="name">Nazwa</label>
	</div>
	<div class="form-floating my-4">
		<input type="number" [(ngModel)]="data.priceEuro" name="priceEuro" class="form-control" />
		<label for="priceEuro">Cena normalna EURO</label>
	</div>
	<div class="form-floating my-4">
		<input type="number" [(ngModel)]="data.priceHr" name="priceHr" class="form-control" />
		<label for="priceHr">Cena normalna KN</label>
	</div>
	<div class="form-floating my-4">
		<input type="number" [(ngModel)]="data.discountValue" name="discountValue" class="form-control" />
		<label for="discountValue">Wartość zniżki</label>
	</div>
	<div class="form-floating my-4">
		<input type="number" [(ngModel)]="data.discountAge" name="discountAge" class="form-control" />
		<label for="discountAge">Wiek >= zniżka 1</label>
	</div>
	<div class="col my-4">
		<label class="form-label" for="description">Krótki opis</label>
		<ckeditor
			id="description"
			name="description"
			[(ngModel)]="data.description"
			[editor]="editor"
			[config]="editorConfig"
		></ckeditor>
	</div>
	<div class="d-flex flex-row-reverse">
		<button class="btn btn-primary" (click)="submit()">Zapisz</button>
	</div>
</div>
